import {AnimatePresence} from 'framer-motion';
import {useState} from 'react';
import {Image, Link} from '@shopify/hydrogen';
import clsx from 'clsx';

// import { AddToCartButton } from '@shopify/hydrogen';
import MoneyPrice from './money/Price.client';
import Popup from '../ui/Popup.client';

export default function Upsell({
  upsell,
  upsellShopify,
  upsellAdded,
  setUpsellAdded,
}: any) {
  const {title, product, heading, subheading, popupLabel} = upsell;
  const {priceRange} = upsellShopify;

  // const { availableForSale, id } = variants?.edges[0]?.node
  const [isOpen, setIsOpen] = useState(false);

  const popup = {
    copy: upsell.popupCopy,
    image: upsell.popupImage,
  };

  return (
    <>
      <div className="mt-7">
        <h6 className="richH6 font-bold">
          {title}{' '}
          {popupLabel && (
            <button
              onClick={() => setIsOpen(true)}
              className="inline text-orange"
            >
              {popupLabel}
            </button>
          )}
        </h6>
        <div
          className={clsx([
            'transition-standard relative mt-4 flex items-center gap-x-5 rounded-sm border-2 bg-light-grey px-2 py-5',
            upsellAdded ? 'border-orange' : 'border-orange/0',
          ])}
        >
          <div className="w-2/3 max-w-[110px] xl:w-full">
            <Link to={`/products/${product?.store?.slug?.current}` || '/'}>
              <Image
                width="110px"
                height="110px"
                data={{url: product?.store?.previewImageUrl}}
                alt={heading}
                loading="eager"
                className="transition-standard w-full rounded-sm object-contain hover:scale-105"
              />
            </Link>
          </div>
          <div className="mr-10 w-full">
            <h6 className="richH6 font-bold">{heading}</h6>
            <p className="richH7">{subheading}</p>
            <div className="blockH9 mt-2 font-bold">
              +<MoneyPrice money={priceRange?.minVariantPrice} />
            </div>
          </div>

          <div className="absolute bottom-3 right-3 w-min">
            <button
              onClick={() => setUpsellAdded((prev: boolean) => !prev)}
              className="flex h-7 w-7 items-center justify-center rounded-full bg-orange/30"
              aria-label="Add"
            >
              <svg
                className={clsx([
                  'transition-standard',
                  upsellAdded ? 'rotate-45' : 'rotate-0',
                ])}
                width="16"
                height="15"
                viewBox="0 0 16 15"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M8.03905 0.398682C7.61271 0.398682 7.26715 0.744243 7.26715 1.17059V6.76739H1.67034C1.244 6.76739 0.898438 7.11295 0.898438 7.5393C0.898438 7.96564 1.244 8.3112 1.67034 8.3112H7.26715V13.908C7.26715 14.3343 7.61271 14.6799 8.03905 14.6799C8.46539 14.6799 8.81096 14.3343 8.81096 13.908V8.3112H14.4078C14.8341 8.3112 15.1797 7.96564 15.1797 7.5393C15.1797 7.11295 14.8341 6.76739 14.4078 6.76739H8.81096V1.17059C8.81096 0.744243 8.46539 0.398682 8.03905 0.398682Z"
                  fill="#F27021"
                />
              </svg>
            </button>
          </div>
        </div>
      </div>

      <AnimatePresence mode="wait">
        {isOpen && <Popup {...popup} setIsOpen={setIsOpen} />}
      </AnimatePresence>
    </>
  );
}
